// removed by extract-text-webpack-plugin
module.exports = {"title":"_2rY8Itk6cE9NjBXdvRr1Fr","grouptitle":"_1cKpVXAO3XeuV9d6QhGTdp","group":"_3HJ_wl2AV-lme8ZlN0bwHJ","groupitems":"iuOKCE_mKx6kFhZ-ox8q","groupmask":"oSZALzWsEGxO7GREFxHoz","selected":"_1vIkWijQztWzLK-dlVQJG8"};


//////////////////
// WEBPACK FOOTER
// ./~/wix-style-react/dist/es/src/SideBar/MenuBlue.scss
// module id = ./node_modules/wix-style-react/dist/es/src/SideBar/MenuBlue.scss
// module chunks = 0